export default __webpack_public_path__ + "static/media/breakfast-logo.c6d190a2.svg";